export const UPDATE_ADVERTISEMENT_START =
  'UPDATE_ADVERTISEMENT_START';
export const UPDATE_ADVERTISEMENT_SUCCESS =
  'UPDATE_ADVERTISEMENT_SUCCESS';
export const UPDATE_ADVERTISEMENT_ERROR =
  'UPDATE_ADVERTISEMENT_ERROR';
